import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { runDataProcessorApi } from "../api's/DataProcessorApi";
import ReactFlowPannel from '../components/react-flow/ReactFlowPannel';
import RunModal from '../components/ruleEngine/RunModal';
import { WorkflowContext } from '../contexts/WorkflowProvider';
import WorkflowNavigateSection from './WorkflowNavigateSection';
import { MAIN } from '../utils/commonConstants';
import Copilot from '../components/react-flow/copilot/Copilot';
import DemoCopilot from '../components/react-flow/copilot/DemoCopilot';
import { DEMO_WORKFLOW_ID_1, DEMO_WORKFLOW_ID_2 } from '../components/react-flow/copilot/copilot-constant/DemoWorkflow';
import { ETL_COPILOT_WEB_SOCKET_URL } from '../BaseUrl';
import { AddXLevels } from '../components/react-flow/copilot/utils/AddXLevel';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// function a11yProps(index) {
//   return {
//     id: `full-width-tab-${index}`,
//     'aria-controls': `full-width-tabpanel-${index}`,
//   };
// }

const CopilotLayout = ({
  workflow,
  toggleCopilot,
  socket,
  chatHistory,
  setChatHistory,
  etlCopilotSocketConnected,
  children
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', height: '100%', position: 'relative', overflow: 'hidden' }}>
      {/* Main Section */}
      <Box
        sx={{
          bgcolor: 'background.paper',
          width: workflow?.copilotOpen ? '75%' : '100%',
          transition: 'width 0.3s ease',
        }}
      >
        {children}
      </Box>

      {/* Copilot Panel */}
      {workflow?.copilotOpen && (
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            height: '100%',
            width: '100%',
            maxWidth: '25%',
            transition: 'transform 0.3s ease, opacity 0.3s ease',
            transform: workflow?.copilotOpen ? 'translateX(0)' : 'translateX(100%)',
            opacity: workflow?.copilotOpen ? 1 : 0,
            pointerEvents: workflow?.copilotOpen ? 'auto' : 'none',
            zIndex: 1,
          }}
        >
          {workflow.workflow_id === DEMO_WORKFLOW_ID_1 || workflow.workflow_id === DEMO_WORKFLOW_ID_2 ? (
            <DemoCopilot etlCopilotSocketConnected={etlCopilotSocketConnected} />
          ) : (
            <Copilot
              socket={socket}
              chatHistory={chatHistory}
              setChatHistory={setChatHistory}
              etlCopilotSocketConnected={etlCopilotSocketConnected}
            />
          )}

          {/* Toggle Button */}
          <IconButton
            onClick={toggleCopilot}
            size="small"
            sx={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#fff',
              border: '1px solid #ccc',
              zIndex: 99,
              '&:hover': {
                backgroundColor: '#fff',
                boxShadow: 2,
              },
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};


const tempData = [];

export default function WorkflowTabs({ processType, processWorkflowType }) {
  const { enqueueSnackbar } = useSnackbar();
  const { workflow, setWorkflow } = useContext(WorkflowContext);
  // const { userId } = useContext(AuthContext);

  const [chatHistory, setChatHistory] = useState([]);
  const [socket, setSocket] = useState(null);
  const [etlCopilotSocketConnected, setEtlCopilotSocketConnected] = useState(false);

  const navigate = useNavigate();
  const theme = useTheme();
  const [value, setValue] = useState(2);
  const [loading, setLoading] = useState(false);
  const [isTabDisabled, setTabIsDisabled] = useState({
    preprocessor: false,
    ruleEngine: false,
    dataStreaming: true,
  });

  const [openRuleEngineModal, setOpenRuleEngineModal] = React.useState(false);

  const toggleCopilot = () => {
    // setCopilotOpen((prev) => !prev);
    setWorkflow({
      ...workflow,
      copilotOpen: !workflow.copilotOpen,
    });
  };

  // const handleClickOpenRuleEngineModal = () => {
  //   setOpenRuleEngineModal(true);
  // };

  const handleCloseRuleEngineModal = () => {
    setOpenRuleEngineModal(false);
  };

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  const handleChangeIndex = (e, index) => {
    setValue(index);
  };

  const dataProcessorFnRef = useRef(null);

  const callDataProcessorFn = () => {
    if (dataProcessorFnRef?.current) {
      const getNodeData = JSON.parse(sessionStorage.getItem('saved_node')) || [];

      const getElementCount = parseInt(sessionStorage.getItem('elementCount') || 0, 10);

      const updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

      if (!getNodeData) {
        enqueueSnackbar('Please enter and submit some data for the dragged steps!!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        // return;
      } else if (getNodeData.length !== getElementCount) {
        enqueueSnackbar('All nodes are not submitted. Please submit all nodes! ', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        // return;
      } else if (updateNodes.length !== 0) {
        enqueueSnackbar('Schema has been updated please validate the schema!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        // saveFormData(e);
        dataProcessorFnRef.current();

        setTimeout(() => {
          const process_type = processType.replace(/\s+/g, '');
          const process_workflow_type = processWorkflowType.replace(/\s+/g, '-');

          const url = `/workflow-${process_type}-${process_workflow_type}?processType=${processType}`;

          processType === 'Generic' ? navigate(`/workflow-cluster`) : navigate(url);
        }, 500);
      }
    }
  };

  const preprocessorFnRef = useRef(null);

  // const callCreatePreprocessorFn = () => {
  //   preprocessorRef.current.preprocessorFnRef();
  // };

  const runPreprocessorFnRef = useRef(null);

  // const callRunPreprocessorFn = () => {
  //   setLoading(true);
  //   preprocessorRef.current.runPreprocessorFnRef();
  //   setLoading(false);
  // };

  const preprocessorRef = useRef({ preprocessorFnRef, runPreprocessorFnRef });

  // const ruleEngineFnRef = useRef(null);

  // const callCreateRuleEngineFn = () => {
  //   ruleEngineFnRef.current();
  // };

  // const pad2 = (n) => {
  //   return n < 10 ? `0${n}` : n;
  // };

  const runDataProcessorWorkflow = async () => {
    setLoading(true);

    const data = {
      workflow_id: workflow.workflow_id,
    };

    try {
      const response = await runDataProcessorApi(data);
      enqueueSnackbar('Workflow Running!', {
        variant: 'success',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      if (response.status === 200) {
        setWorkflow({
          ...workflow,
          latest_execution_id: response.data?.execution_id,
        });
        sessionStorage.removeItem('nodeStatus');
      }
    } catch (error) {
      if (error.response.status === 403) {
        enqueueSnackbar('You have only Read Permission !!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (error.response.status === 500) {
        enqueueSnackbar(error.response.data || 'Internal Server Error', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // Establish WebSocket connection on component mount
    const ws = new WebSocket(ETL_COPILOT_WEB_SOCKET_URL);

    ws.onopen = () => {
      console.log('✅ WebSocket connected');
      setEtlCopilotSocketConnected(true);
      setChatHistory([]);
    };

    ws.onmessage = (event) => {
      const parsed = JSON.parse(event.data);
      const { message, level, timestamp } = parsed.result;
      console.log('ws: ', parsed.result);
      let parsePipeline;
      if (level.toLowerCase() === 'pipeline') {
        const msg = JSON.parse(message);
        if (Array.isArray(msg)) {
          parsePipeline = AddXLevels(msg);
        } else {
          parsePipeline = [];
        }
      }
      setChatHistory((prev) => [
        ...prev,
        {
          content: level.toLowerCase() === 'pipeline' ? parsePipeline : message,
          type: level.toLowerCase() === 'warning' || level.toLowerCase() === 'error' ? 'info' : level,
          sender: 'copilot',
          timestamp,
        },
      ]);
      tempData.push({
        content: level.toLowerCase() === 'pipeline' ? parsePipeline : message,
        type: level.toLowerCase() === 'warning' || level.toLowerCase() === 'error' ? 'info' : level,
        sender: 'copilot',
        timestamp,
      });
      if (level.toLowerCase() === 'pipeline') {
        console.log('tempData: ', tempData);
      }
    };

    ws.onerror = (err) => {
      console.error('WebSocket error', err);
      setEtlCopilotSocketConnected(false);
      // enqueueSnackbar(`Error while connecting to ETL Copilot server!`, {
      //   variant: 'error',
      //   autoHideDuration: 3500,
      //   anchorOrigin: { vertical: 'top', horizontal: 'right' },
      // });
    };

    ws.onclose = () => {
      console.log('❌ WebSocket disconnected');
      setEtlCopilotSocketConnected(false);
      // enqueueSnackbar(`Lost connection to the ETL Copilot server!`, {
      //   variant: 'error',
      //   autoHideDuration: 3500,
      //   anchorOrigin: { vertical: 'top', horizontal: 'right' },
      // });
    };

    setSocket(ws);

    // Clean up on component unmount
    return () => {
      ws.close();
    };
  }, []);

  useEffect(() => {
    // if (workflow.process_type === 'Data Quality') {
    //   setValue(1);
    // } else if (
    //   workflow.process_type === 'Modelling & Analytics' ||
    //   workflow.process_type === MAIN.xperience360 ||
    //   workflow.process_type === 'Customer Segmentation' ||
    //   workflow.process_type === 'Data Copy'
    // ) {
    //   setValue(2);
    // } else {
    //   setValue(0);
    // }
    setValue(2);
  }, [workflow]);

  useEffect(() => {
    switch (workflow.process_type) {
      case 'Data Ingestion':
        setTabIsDisabled({
          ...isTabDisabled,
          preprocessor: false,
          ruleEngine: true,
        });
        break;
      case 'Data Quality':
        setTabIsDisabled({
          ...isTabDisabled,
          preprocessor: true,
          ruleEngine: false,
        });
        break;

      case 'Modelling & Analytics':
      case MAIN.xperience360:
        setTabIsDisabled({
          ...isTabDisabled,
          preprocessor: true,
          ruleEngine: true,
        });
        break;

      default:
        setTabIsDisabled({
          ...isTabDisabled,
          preprocessor: false,
          ruleEngine: false,
        });
    }
  }, [workflow.process_type, isTabDisabled.ruleEngine, isTabDisabled.preprocessor]);

  return (
    <CopilotLayout
      workflow={workflow}
      toggleCopilot={toggleCopilot}
      socket={socket}
      chatHistory={chatHistory}
      setChatHistory={setChatHistory}
      etlCopilotSocketConnected={etlCopilotSocketConnected}
    >
      {/* PROCESS TYPE: DEFAULT */}
      {processType !== 'modelling-analytics' &&
        processType !== MAIN.xmdm360 &&
        processType !== 'customer-segmentation' && (
          <>
            <ReactFlowPannel ref={dataProcessorFnRef} setLoading={setLoading} />
            <WorkflowNavigateSection
              handleChangeIndex={handleChangeIndex}
              value={value}
              callDataProcessorFn={callDataProcessorFn}
              loading={loading}
              runDataProcessorWorkflow={runDataProcessorWorkflow}
              processType={processType}
              processWorkflowType={processWorkflowType}
            />
            <RunModal
              workflowId={workflow.workflow_id}
              openRuleEngineModal={openRuleEngineModal}
              handleCloseRuleEngineModal={handleCloseRuleEngineModal}
            />
          </>
        )}

      {/* PROCESS TYPE: MODELLING ANALYTICS */}
      {processType === 'modelling-analytics' && (
        <>
          <AppBar position="static">
            <Tabs value={value} onChange={handleChangeIndex} variant="scrollable" scrollButtons="auto">
              <Tab label="Tab 1" />
              <Tab label="Tab 2" />
              <Tab label="Tab 3" />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <ReactFlowPannel ref={dataProcessorFnRef} setLoading={setLoading} />
            <WorkflowNavigateSection
              handleChangeIndex={handleChangeIndex}
              value={value}
              callDataProcessorFn={callDataProcessorFn}
              loading={loading}
              runDataProcessorWorkflow={runDataProcessorWorkflow}
              processType={processType}
              processWorkflowType={processWorkflowType}
            />
          </TabPanel>
          <RunModal
            workflowId={workflow.workflow_id}
            openRuleEngineModal={openRuleEngineModal}
            handleCloseRuleEngineModal={handleCloseRuleEngineModal}
          />
        </>
      )}

      {/* PROCESS TYPE: XMDM360 */}
      {processType === MAIN.xmdm360 && (
        <>
          <ReactFlowPannel ref={dataProcessorFnRef} setLoading={setLoading} />
          <WorkflowNavigateSection
            handleChangeIndex={handleChangeIndex}
            value={value}
            callDataProcessorFn={callDataProcessorFn}
            loading={loading}
            runDataProcessorWorkflow={runDataProcessorWorkflow}
            processType={processType}
            processWorkflowType={processWorkflowType}
          />
          <RunModal
            workflowId={workflow.workflow_id}
            openRuleEngineModal={openRuleEngineModal}
            handleCloseRuleEngineModal={handleCloseRuleEngineModal}
          />
        </>
      )}

      {/* PROCESS TYPE: CUSTOMER SEGMENTATION */}
      {processType === 'customer-segmentation' && (
        <>
          <AppBar position="static">
            <Tabs value={value} onChange={handleChangeIndex} variant="scrollable" scrollButtons="auto">
              <Tab label="Tab 1" />
              <Tab label="Tab 2" />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0} dir={theme.direction}>
            <ReactFlowPannel ref={dataProcessorFnRef} setLoading={setLoading} />
            <WorkflowNavigateSection
              handleChangeIndex={handleChangeIndex}
              value={value}
              callDataProcessorFn={callDataProcessorFn}
              loading={loading}
              runDataProcessorWorkflow={runDataProcessorWorkflow}
              processType={processType}
              processWorkflowType={processWorkflowType}
            />
          </TabPanel>
          <RunModal
            workflowId={workflow.workflow_id}
            openRuleEngineModal={openRuleEngineModal}
            handleCloseRuleEngineModal={handleCloseRuleEngineModal}
          />
        </>
      )}
    </CopilotLayout>
  );

}
